import { render, staticRenderFns } from "./CheckoutOrder.vue?vue&type=template&id=031697e6"
import script from "./CheckoutOrder.vue?vue&type=script&lang=ts"
export * from "./CheckoutOrder.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutOrder.vue?vue&type=style&index=0&id=031697e6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031697e6')) {
      api.createRecord('031697e6', component.options)
    } else {
      api.reload('031697e6', component.options)
    }
    module.hot.accept("./CheckoutOrder.vue?vue&type=template&id=031697e6", function () {
      api.rerender('031697e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/CheckoutOrder.vue"
export default component.exports